import React from 'react';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';

import { configureRoutes } from './routes';
import { configureStore } from './store';

import 'styles/global.scss';

const store = configureStore();
const routes = configureRoutes(store);

export default function App() {
  return (
    <Provider store={store}>
      <Router history={browserHistory} routes={routes} />
    </Provider>
  );
}
